import { AlertTriangle } from "lucide-react";
import { useMyProcedures } from "@/api/portal";
import { PROCEDURE_STATUS_LABEL, ProcedureStatus, isProcedureOverdue } from "@/api/procedures";

const STATUS_STYLE: Record<ProcedureStatus, string> = {
  PENDIENTE: "bg-gray-100 text-gray-600",
  EN_PROCESO: "bg-blue-100 text-blue-700",
  EN_REVISION: "bg-purple-100 text-purple-700",
  APROBADO: "bg-teal-100 text-teal-700",
  FINALIZADO: "bg-green-100 text-green-700",
  CANCELADO: "bg-gray-100 text-gray-400",
};

export default function PortalProceduresPage() {
  const { data, isLoading } = useMyProcedures({ pageSize: 100 });
  const procedures = data?.data ?? [];

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-semibold text-gray-900">Trámites</h1>
        <p className="text-sm text-gray-500">Procesos ante entidades externas gestionados por la firma para usted.</p>
      </div>

      <div className="card overflow-hidden">
        <table className="min-w-full divide-y divide-gray-200 text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left font-medium text-gray-500">Trámite</th>
              <th className="px-4 py-3 text-left font-medium text-gray-500">Entidad</th>
              <th className="px-4 py-3 text-left font-medium text-gray-500">Vence</th>
              <th className="px-4 py-3 text-left font-medium text-gray-500">Estado</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {isLoading && (
              <tr>
                <td colSpan={4} className="px-4 py-6 text-center text-gray-400">
                  Cargando...
                </td>
              </tr>
            )}
            {!isLoading && procedures.length === 0 && (
              <tr>
                <td colSpan={4} className="px-4 py-10 text-center text-gray-400">
                  No tiene trámites registrados.
                </td>
              </tr>
            )}
            {procedures.map((procedure) => (
              <tr key={procedure.id}>
                <td className="px-4 py-3">
                  <p className="font-medium text-gray-900">{procedure.title}</p>
                  {procedure.procedureType && <p className="text-xs text-gray-400">{procedure.procedureType}</p>}
                </td>
                <td className="px-4 py-3 text-gray-600">{procedure.entityName || "—"}</td>
                <td className="px-4 py-3">
                  {procedure.dueDate ? (
                    <span className={isProcedureOverdue(procedure) ? "inline-flex items-center gap-1 text-red-600" : "text-gray-600"}>
                      {isProcedureOverdue(procedure) && <AlertTriangle size={12} />}
                      {procedure.dueDate}
                    </span>
                  ) : (
                    <span className="text-gray-400">—</span>
                  )}
                </td>
                <td className="px-4 py-3">
                  <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${STATUS_STYLE[procedure.status]}`}>
                    {PROCEDURE_STATUS_LABEL[procedure.status]}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
